import React, { useState, useEffect } from "react";
import { CalendarDays, Clock } from "lucide-react";
import { Badge } from "../../../ui/badge";
import { Card, CardContent, CardHeader } from "../../../ui/card";
import { getConfig } from "../../../common/env-config";

const getBadgeColor = (type) => {
  switch (type) {
    case "New":
      return "bg-oye-soft-green text-green-800 hover:bg-oye-soft-green"
    case "Improved":
      return "bg-oye-soft-peach text-amber-800 hover:bg-oye-soft-peach"
    case "Fixed":
      return "bg-oye-soft-yellow text-amber-800 hover:bg-oye-soft-yellow"
    case "Announcement":
      return "bg-oye-light-purple text-purple-800 hover:bg-oye-light-purple"
    default:
      return ""
  }
}

const UpdatesList = ({ activeFilter }) => {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        const { baseUrl } = getConfig();

        const response = await fetch(
          `${baseUrl}/product/updates/list?isDraft=false`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setUpdates(result.data || []);
      } catch (err) {
        console.error("Error fetching updates:", err);
      } finally {
      }
    };

    fetchUpdates();
  }, []);

  const filteredUpdates = React.useMemo(() => {
    let filtered;
    // const publishedUpdates = updates.filter(
    //   (update) => update.isDraft === false
    // );
    // Filter by status
    if (activeFilter === "All") {
      filtered = updates;
    } else {
      filtered = updates.filter(
        (update) =>
          update.productUpdateStatus &&
          update.productUpdateStatus.toLowerCase() === activeFilter.toLowerCase()
      );
    }

    // Sort by createdAt date - latest first (descending order)
    return filtered.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA; // Latest first
    });
  }, [updates, activeFilter]);

  return (
    <div className="space-y-8">
      {filteredUpdates.map((update) => (
        <Card
          key={update.id}
          className="overflow-hidden transition-all duration-300 hover:transform hover:scale-[1.01] relative"
          style={{
            boxShadow: "0 10px 30px -15px rgba(82, 56, 128, 0.15)",
            borderRadius: "12px"
          }}
        >
          <div className="absolute w-[180px] h-[180px] rounded-full bg-oye-light-purple/10 blur-3xl -right-20 -top-20 z-0"></div>
          <CardHeader className="bg-gray-50/80 pb-2 relative z-10">
            <div className="flex justify-between items-start">
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <CalendarDays className="h-4 w-4" />
                {/* <span>{update.createdAt}</span> */}
                {new Date(update.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
                {new Date(update.createdAt).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                }) && (
                  <>
                    <span>•</span>
                    <Clock className="h-4 w-4" />
                    <span>
                      {new Date(update.createdAt).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </>
                )}
              </div>
              <Badge className={`${getBadgeColor(update.productUpdateStatus)} border-none`}>
                {update.productUpdateStatus}
              </Badge>
            </div>
          </CardHeader>
          <CardContent className="pt-4 relative z-10">
            <h3 className="text-xl font-semibold mb-2">{update.title}</h3>
            <p className="text-gray-600">{update.description}</p>
          </CardContent>
        </Card>
      ))}

      {filteredUpdates.length === 0 && (
        <div className="text-center py-10">
          <p className="text-gray-500">No updates found for this category.</p>
        </div>
      )}
    </div>
  )
}

export default UpdatesList;
